module.exports = __webpack_public_path__ + "static/img/example_screenshot.1ea9aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/example_screenshot.png
// module id = KtjH
// module chunks = 0